module.exports = __webpack_public_path__ + "static/media/man-animal-african-header.55246984.png";